import { Component } from '@angular/core';
import { EmailAddress } from 'src/shared/api';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { NgControl, FormBuilder, Validators } from '@angular/forms';

export const emailAddressFormConfig: FormConfig<Required<EmailAddress>> = {
	id: [''],
	description: [''],
	email: ['', [Validators.email, Validators.required]],
	isPrimary: [''],
};

@Component({
	selector: 'rpshared-email-address',
	templateUrl: './email-address.component.html',
	styleUrls: ['./email-address.component.css'],
})
export class EmailAddressComponent extends CustomFormAccessor<EmailAddress> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, emailAddressFormConfig);
	}

	// model --> view
	writeValue(value: EmailAddress): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: EmailAddress) => void) {
		super.registerOnChange(fn);
	}
}
